
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">{{ entityName }}</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs"><a [routerLink]="['/' + breadcrumb.queryAction]" [queryParams]="breadcrumb.queryParams">{{ breadcrumb.text }}</a></li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="table-card">
        <div class="row">
          <div class="col">
            <sandy-import [entityId]="entityId" [entityParam]="entityParam" (error)="handleError($event)"></sandy-import>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>